import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import HCharts from "../HighLightEcharts";
import Charts from "../Echarts";
import shanghai from "../../../utils/m4k/three/shanghai";
import anhui from "../../../utils/m4k/three/anhui";
import js from "../../../utils/m4k/three/jiangsu";
import zhej from "../../../utils/m4k/three/zhejiang";

import map from "../../../utils/m4k/three/map";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mapTitle: {
      height: "10vh",
      color: "#6effff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "60px",
    },
  })
);

const TriRight: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row">
      <Grid item xs={3}>
        <Charts
          option={js}
          style={{
            height: "30vh",
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <Charts
          option={zhej}
          style={{
            height: "30vh",
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <Charts
          option={shanghai}
          style={{
            height: "30vh",
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <Charts
          option={anhui}
          style={{
            height: "30vh",
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <div className={classes.mapTitle}>长三角化工企业分布图</div>
      </Grid>
      <Grid item xs={12}>
        <Charts option={map} style={{ height: "50vh" }} />
      </Grid>
    </Grid>
  );
};

export default TriRight;
